// src/components/technician-tabs/TabIntroductor.js
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Grid, TextField, Paper, Stack
} from '@mui/material';
import { useI18n } from '../../i18n/i18n';
import { getData } from '../../services/storageService';

const TabIntroductor = ({ data, updateData }) => {
    const { t } = useI18n();
    const [assignments, setAssignments] = useState(null);
    const [staff, setStaff] = useState([]);
    const [localData, setLocalData] = useState(data || {});

    useEffect(() => {
        const fetchData = async () => {
            const staffData = await getData('staff') || [];
            setStaff(staffData.filter(s => s.status === 'active').map(s => s.name));
            
            const savedAssignments = await getData('ironing_assignments');
            setAssignments(savedAssignments);
        };
        fetchData();
    }, []);

    useEffect(() => {
        setLocalData(data || {});
    }, [data]);

    const handleInputChange = (field, value) => {
        const updatedData = {
            ...localData,
            [field]: value
        };
        setLocalData(updatedData);
        updateData(updatedData);
    };

    const ViaCard = ({ viaNumber }) => {
        const assignment = assignments?.introductor?.[`via${viaNumber}`];
        const viaData = {
            worker: localData[`via${viaNumber}_worker`] || assignment?.worker || '',
            pieces: localData[`via${viaNumber}_pieces`] || assignment?.pieces || '',
            val1: localData[`via${viaNumber}_val1`] || '',
            val2: localData[`via${viaNumber}_val2`] || ''
        };

        return (
            <Paper sx={{ p: 2, height: '100%' }}>
                <Typography variant="h6" gutterBottom>
                    {t('field_via')} {viaNumber}
                </Typography>
                <Stack spacing={2}>
                    <TextField
                        select
                        label={t('ironing_worker')}
                        value={viaData.worker}
                        onChange={(e) => handleInputChange(`via${viaNumber}_worker`, e.target.value)}
                        fullWidth
                        size="small"
                        SelectProps={{ native: true }}
                    >
                        <option value=""></option>
                        {staff.map(name => (
                            <option key={name} value={name}>{name}</option>
                        ))}
                    </TextField>
                    <TextField
                        label={t('ironing_pieces_count')}
                        type="number"
                        value={viaData.pieces}
                        onChange={(e) => handleInputChange(`via${viaNumber}_pieces`, e.target.value)}
                        fullWidth
                        size="small"
                        inputProps={{ 
                            min: "0",
                            step: "1"
                        }}
                    />
                    <TextField
                        label={`${t('field_value')} 1`}
                        type="number"
                        value={viaData.val1}
                        onChange={(e) => handleInputChange(`via${viaNumber}_val1`, e.target.value)}
                        fullWidth
                        size="small"
                        inputProps={{ 
                            min: "0",
                            step: "1"
                        }}
                    />
                    <TextField
                        label={`${t('field_value')} 2`}
                        type="number"
                        value={viaData.val2}
                        onChange={(e) => handleInputChange(`via${viaNumber}_val2`, e.target.value)}
                        fullWidth
                        size="small"
                        inputProps={{ 
                            min: "0",
                            step: "1"
                        }}
                    />
                </Stack>
            </Paper>
        );
    };

    return (
        <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                {t('tech_form_tab_introductor')}
            </Typography>
            
            {/* Картки для кожної лінії */}
            <Grid container spacing={3}>
                {[1, 2, 3].map(via => (
                    <Grid item xs={12} md={4} key={via}>
                        <ViaCard viaNumber={via} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default TabIntroductor;